import { render, staticRenderFns } from "./triage.vue?vue&type=template&id=31b3dfd4"
import script from "./triage.vue?vue&type=script&lang=ts"
export * from "./triage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports